import React, { useMemo } from "react";
import { RadioButton } from "@whatslly/ui-components/v2/BaseElements/RadioButton";
import styles from "../VerifyPhoneNumberVerifyMethodModal/VerifyPhoneNumberVerifyMethodModal.module.scss";
import { useTranslation } from "react-i18next";

export type RadioOption = { value: "SMS" | "VOICE"; optionLabel: string };

export const VerifyMethod: React.FC<{ setVerifyMethod: (data: RadioOption | undefined) => void }> = ({ setVerifyMethod }) => {
  const { t } = useTranslation();
  const radioOptions: RadioOption[] = useMemo(() => {
    return [
      {
        optionLabel: t("whatsapp_business_api_settings_page.verifyMethod.sms"),
        value: "SMS",
      },
      {
        optionLabel: t("whatsapp_business_api_settings_page.verifyMethod.voice"),
        value: "VOICE",
      },
    ];
  }, [t]);
  return (
    <RadioButton
      onChange={(val) => setVerifyMethod(radioOptions.find((opt) => opt.value === val.target.value))}
      radioButtonContainerClassName={styles.radios}
      defaultCheck={radioOptions[0]}
      options={radioOptions}
      textFontSize={`small`}
    />
  );
};
